export default "__VITE_ASSET__DIKcpe0P__"